export const ADMINISTRATION_HAS_ERRORED = '[Administration] ADMINISTRATION_HAS_ERRORED';
export type ADMINISTRATION_HAS_ERRORED = typeof ADMINISTRATION_HAS_ERRORED;

export const GET_USERS = '[Administration] GET_USERS';
export type GET_USERS = typeof GET_USERS;

export const GET_USERS_SUCCESS = '[Administration] GET_USERS_SUCCESS';
export type GET_USERS_SUCCESS = typeof GET_USERS_SUCCESS;

export const GET_USER = '[Administration] GET_USER';
export type GET_USER = typeof GET_USER;

export const GET_USER_SUCCESS = '[Administration] GET_USER_SUCCESS';
export type GET_USER_SUCCESS = typeof GET_USER_SUCCESS;

export const CREATE_USER = '[Administration] CREATE_USER';
export type CREATE_USER = typeof CREATE_USER;

export const CREATE_USER_SUCCESS = '[Administration] CREATE_USER_SUCCESS';
export type CREATE_USER_SUCCESS = typeof CREATE_USER_SUCCESS;

export const UPDATE_USER = '[Administration] UPDATE_USER';
export type UPDATE_USER = typeof UPDATE_USER;

export const UPDATE_USER_SUCCESS = '[Administration] UPDATE_USER_SUCCESS';
export type UPDATE_USER_SUCCESS = typeof UPDATE_USER_SUCCESS;

export const SET_PASSWORD = '[Administration] SET_PASSWORD';
export type SET_PASSWORD = typeof SET_PASSWORD;

export const SET_PASSWORD_SUCCESS = '[Administration] SET_PASSWORD_SUCCESS';
export type SET_PASSWORD_SUCCESS = typeof SET_PASSWORD_SUCCESS;

export const UPDATE_PERMISSION = '[Administration] UPDATE_PERMISSION';
export type UPDATE_PERMISSION = typeof UPDATE_PERMISSION;

export const UPDATE_PERMISSION_SUCCESS = '[Administration] UPDATE_PERMISSION_SUCCESS';
export type UPDATE_PERMISSION_SUCCESS = typeof UPDATE_PERMISSION_SUCCESS;

export const GET_TOTP_CONF = '[Administration] GET_TOTP_CONF';
export type GET_TOTP_CONF = typeof GET_TOTP_CONF;

export const GET_TOTP_CONF_SUCCESS = '[Administration] GET_TOTP_CONF_SUCCESS';
export type GET_TOT_CONF_SUCCESS = typeof GET_TOTP_CONF_SUCCESS;

export const CREATE_TOTP_CONF = '[Administration] CREATE_TOTP_CONF';
export type CREATE_TOTP_CONF = typeof CREATE_TOTP_CONF;

export const CREATE_TOTP_CONF_SUCCESS = '[Administration] CREATE_TOTP_CONF_SUCCESS';
export type CREATE_TOT_CONF_SUCCESS = typeof CREATE_TOTP_CONF_SUCCESS;

export const DELETE_TOTP_CONF = '[Administration] DELETE_TOTP_CONF';
export type DELETE_TOTP_CONF = typeof DELETE_TOTP_CONF;

export const DELETE_TOTP_CONF_SUCCESS = '[Administration] DELETE_TOTP_CONF_SUCCESS';
export type DELETE_TOT_CONF_SUCCESS = typeof DELETE_TOTP_CONF_SUCCESS;

export const SET_SELECTED_USER = '[Administration] SET_SELECTED_USER';
export type SET_SELECTED_USER = typeof SET_SELECTED_USER;

export const GET_EMAIL_CONFIG = '[Administration] GET_EMAIL_CONFIG';
export type GET_EMAIL_CONFIG = typeof GET_EMAIL_CONFIG;

export const GET_EMAIL_CONFIG_SUCCESS = '[Administration] GET_EMAIL_CONFIG_SUCCESS';
export type GET_EMAIL_CONFIG_SUCCESS = typeof GET_EMAIL_CONFIG_SUCCESS;

export const SET_EMAIL_CONFIG = '[Administration] SET_EMAIL_CONFIG';
export type SET_EMAIL_CONFIG = typeof SET_EMAIL_CONFIG;

export const SET_EMAIL_CONFIG_SUCCESS = '[Administration] SET_EMAIL_CONFIG_SUCCESS';
export type SET_EMAIL_CONFIG_SUCCESS = typeof SET_EMAIL_CONFIG_SUCCESS;